/* flavour-description.js
   Shows the selected flavour's description under the variant selector. Extracted from the old
   inline <script> in flavour-description.liquid so it can ALSO run inside the quick-add slide-up
   (inline scripts don't execute when injected via innerHTML). Scopes to the nearest product
   context (.product-info on the PDP, quick-add-drawer in the slide-up) and reads its data from an
   adjacent JSON script, so multiple instances on one page never cross-wire.
   Exposes window.FlavourDescription.initRoot(root) for the quick-add to call after injecting. */
(function () {
  'use strict';
  if (window.__flavourDescLoaded) return;
  window.__flavourDescLoaded = true;

  function cleanName(name) {
    if (!name) return null;
    var c = String(name).replace(/^#/, '').trim();
    var p = c.split(' ');
    if (p.length > 1 && !isNaN(parseInt(p[0], 10))) return p.slice(1).join(' ');
    return c;
  }
  function normKey(s) { return s ? String(s).trim().toLowerCase() : ''; }

  function initOne(descEl) {
    if (descEl.dataset.fdReady) return;
    descEl.dataset.fdReady = '1';

    var scope = descEl.closest('.product-info, quick-add-drawer, .cc-main-product, main') || document;
    var flavourPos = parseInt(descEl.getAttribute('data-flavour-position'), 10);
    var textEl = descEl.querySelector('.flavour-description__text') || descEl;

    // Flavour name -> description (rendered in an adjacent JSON script by flavour-description.liquid).
    var dataEl = descEl.querySelector('script.flavour-desc-data');
    var flavourData = {};
    try { flavourData = dataEl ? JSON.parse(dataEl.textContent) : {}; } catch (e) { flavourData = {}; }

    // variant id -> flavour value, from the variant-picker's product JSON in this scope.
    var variantLookup = {};
    var picker = scope.querySelector('variant-picker');
    var vpScript = picker && picker.querySelector('script[type="application/json"]');
    if (vpScript && flavourPos) {
      try {
        var vp = JSON.parse(vpScript.textContent);
        ((vp.product && vp.product.variants) || []).forEach(function (v) {
          variantLookup[v.id] = v['option' + flavourPos];
        });
      } catch (e) { /* leave lookup empty */ }
    }

    // Look the form up fresh each time — in the quick-add the footer form is populated AFTER this
    // module inits (updateContent runs before updateForm), so a cached reference would be null.
    function getForm() {
      return scope.querySelector('.js-product-form-main') || descEl.closest('form') || scope.querySelector('form[action*="/cart/add"]');
    }

    function update(variantId) {
      var flavourName = variantLookup[variantId];
      var cleaned = cleanName(flavourName);
      var key = normKey(cleaned || flavourName);
      var match = key && flavourData[key];
      if (match) { textEl.innerHTML = match; descEl.style.display = ''; }
      else { textEl.innerHTML = ''; descEl.style.display = 'none'; }
    }
    function committedId() {
      var f = getForm();
      var i = f && f.querySelector('input[name="id"]');
      if (i && i.value) return parseInt(i.value, 10);
      var urlV = new URLSearchParams(window.location.search).get('variant');
      return urlV ? parseInt(urlV, 10) : null;
    }
    function refresh() {
      var id = committedId();
      if (id) update(id);
      else { textEl.innerHTML = ''; descEl.style.display = 'none'; }
    }

    if (picker) picker.addEventListener('on:variant:change', refresh);

    // Safety net for any path that mutates the form id without emitting the event. Self-clears
    // once the element leaves the DOM (quick-add close) so instances don't pile up.
    var last = '';
    var poll = setInterval(function () {
      if (!descEl.isConnected) { clearInterval(poll); return; }
      var f = getForm();
      var i = f && f.querySelector('input[name="id"]');
      var cur = (i && i.value) || new URLSearchParams(window.location.search).get('variant') || '';
      if (cur !== last) { last = cur; refresh(); }
    }, 250);

    refresh();
  }

  window.FlavourDescription = window.FlavourDescription || {
    initRoot: function (root) {
      Array.prototype.slice.call((root || document).querySelectorAll('[data-flavour-description]')).forEach(initOne);
    }
  };

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { window.FlavourDescription.initRoot(document); });
})();
